import { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { Button } from "expano-components";

const ConfirmModal = ({ text, title, handleClose, handleConfirm }) => {
  const [active, setActive] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setActive(true);
    }, 200);
  }, []);
  return ReactDOM.createPortal(
    <div className="popup-wrapper">
      <div className={`popup ${active ? "active" : ""}`}>
        <header className="popup__header">
          <h2 className="dashboard__title heading">{title}</h2>
          <Button type="close" onClick={handleClose} />
        </header>
        <div className="popup__body">
          <div className="popup-text">
            <p>{text}</p>
          </div>
        </div>
        <div
          className="popup__footer"
          style={{
            padding: "10px 15px",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <Button type="cancel" text="Nie" onClick={handleClose} />
          <button type="button" onClick={handleConfirm} className="btn btn-sm btn-green">
            <span>Tak, potwierdzam</span>
          </button>
        </div>
      </div>
    </div>,
    document.getElementById("root")
  );
};

export default ConfirmModal;
